import React from 'react';
import { motion } from 'framer-motion';
import { CarIcon, MessageCircleIcon, CreditCardIcon, ShieldIcon, SearchIcon, TruckIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: CarIcon,
    titleKey: 'services.service1Title',
    descKey: 'services.service1Desc'
  }, {
    icon: MessageCircleIcon,
    titleKey: 'services.service2Title',
    descKey: 'services.service2Desc'
  }, {
    icon: CreditCardIcon,
    titleKey: 'services.service3Title',
    descKey: 'services.service3Desc'
  }, {
    icon: ShieldIcon,
    titleKey: 'services.service4Title',
    descKey: 'services.service4Desc'
  }, {
    icon: SearchIcon,
    titleKey: 'services.service5Title',
    descKey: 'services.service5Desc'
  }, {
    icon: TruckIcon,
    titleKey: 'services.service6Title',
    descKey: 'services.service6Desc'
  }];
  return <section id="sluzby" className="py-24 md:py-32 bg-[#0a0a0a]" data-id="element-137">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-138">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-139">
          <span className="text-[#c8a96e] text-sm font-semibold tracking-widest uppercase mb-4 block" data-id="element-140">
            {t('services.sectionLabel')}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-141">
            {t('services.title')}
          </h2>
          <p className="text-[#a3a3a3] text-lg max-w-2xl mx-auto" data-id="element-142">
            {t('services.subtitle')}
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-143">
          {services.map((service, index) => <motion.div key={service.titleKey} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group bg-[#1c1c1c] border border-[#2a2a2a] rounded-xl p-8 hover:border-[#c8a96e]/30 transition-all duration-300" data-id="element-144">
              <div className="w-14 h-14 bg-[#c8a96e]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#c8a96e]/20 transition-colors" data-id="element-145">
                <service.icon className="w-7 h-7 text-[#c8a96e]" data-id="element-146" />
              </div>
              <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-[#c8a96e] transition-colors" data-id="element-147">
                {t(service.titleKey)}
              </h3>
              <p className="text-[#737373] leading-relaxed" data-id="element-148">
                {t(service.descKey)}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}